import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PublishIcon from '@mui/icons-material/Publish';
import VerifiedIcon from '@mui/icons-material/Verified';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ArchiveIcon from '@mui/icons-material/Archive';

const ContentTabs = ({ value, onChange }) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs 
        value={value} 
        onChange={onChange}
        aria-label="content tabs"
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab icon={<EditNoteIcon />} label="Drafted" iconPosition="start" id="tab-0" aria-controls="tabpanel-0" />
        <Tab icon={<PublishIcon />} label="Published" iconPosition="start" id="tab-1" aria-controls="tabpanel-1" />
        <Tab icon={<VerifiedIcon />} label="Approved" iconPosition="start" id="tab-2" aria-controls="tabpanel-2" />
        <Tab icon={<RocketLaunchIcon />} label="Released" iconPosition="start" id="tab-3" aria-controls="tabpanel-3" />
        <Tab icon={<ArchiveIcon />} label="Archived" iconPosition="start" id="tab-4" aria-controls="tabpanel-4" />
      </Tabs>
    </Box>
  );
};

export default ContentTabs;